import AuthApi from './AuthApi';

const authApi = new AuthApi();

export const getAuthApi = () => authApi;
